module.exports = __webpack_public_path__ + "media/video-login.49690823.mp4";